import { ContractDetailsModel } from '@/modules/drivers/types/contracts'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { Checkbox } from '@/ui'
import * as React from 'react'

interface Props {
  data: ContractDetailsModel | null
  setData: React.Dispatch<React.SetStateAction<ContractDetailsModel | null>>
  disabled?: boolean
}

const RateReduce = ({ data, setData, disabled = false }: Props) => {
  const { t } = useLocalize()
  React.useEffect(() => {
    if (data) {
      if (
        data?.reduceRateOfAbsenceForSickLeave ||
        data?.reduceRateOfAbsenceForLeave ||
        data?.reduceRateOfAbsenceForNotPaidLeave
      ) {
        setReduce(true)
      }
    }
  }, [data])
  const [reduce, setReduce] = React.useState<boolean>(false)

  return (
    <div
      className={`tw-w-full tw-space-y-3 tw-border-t tw-border-gray-300 tw-pt-3`}
    >
      <div className="tw-flex tw-items-center tw-gap-2">
        <Checkbox
          disabled={disabled}
          checked={reduce}
          onChange={(e) => {
            setReduce(e.target.checked)
            if (e.target.checked) {
              setData({
                ...data,
                reduceRateOfAbsenceForSickLeave: true,
                reduceRateOfAbsenceForLeave: true,
                reduceRateOfAbsenceForNotPaidLeave: true,
              })
            }
          }}
        />
        <p className="tw-text-sm tw-text-content-base">
          {t('contract.reduce-on-absence')}
        </p>
      </div>

      {reduce && (
        <div className="tw-space-y-3 tw-px-5">
          <div className="tw-flex tw-items-center tw-gap-2">
            <Checkbox
              checked={data?.reduceRateOfAbsenceForSickLeave}
              onChange={(e) =>
                setData({
                  ...data,
                  reduceRateOfAbsenceForSickLeave: e.target.checked,
                })
              }
            />
            <p className="tw-text-sm tw-text-content-base">
              {t('contract.sick-leave-1-30')}
            </p>
          </div>
          <div className="tw-flex tw-items-center tw-gap-2">
            <Checkbox
              checked={data?.reduceRateOfAbsenceForLeave}
              onChange={(e) =>
                setData({
                  ...data,
                  reduceRateOfAbsenceForLeave: e.target.checked,
                })
              }
            />
            <p className="tw-text-sm tw-text-content-base">
              Urlop wypoczynkowy wg wymiaru
            </p>
          </div>
          <div className="tw-flex tw-items-center tw-gap-2">
            <Checkbox
              checked={data?.reduceRateOfAbsenceForNotPaidLeave}
              onChange={(e) =>
                setData({
                  ...data,
                  reduceRateOfAbsenceForNotPaidLeave: e.target.checked,
                })
              }
            />
            <p className="tw-text-sm tw-text-content-base">
              {t('contract.unpaid-leave-by-dimension')}
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default RateReduce
